module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: _vm.componentId
  }, [(_vm.item) ? _c('button', {
    staticClass: "button success",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]) : _c('button', {
    staticClass: "button small",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Add new Segment Rate")]), (_vm.loading) ? _c('loading-spinner') : [(_vm.item !== null) ? _c('h2', [_vm._v("Segment Rate SGR" + _vm._s(_vm.item.id) + "- SG" + _vm._s(_vm.item.segment.id) + " " + _vm._s(_vm.item.segment.name))]) : _c('h2', [_vm._v("Add new Segment Rate")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Reservation Rate"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.reservation_rate_id),
      expression: "body.reservation_rate_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "reservation_rate_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.reservation_rates), function(reservation_rate) {
    return _c('option', {
      domProps: {
        "value": reservation_rate.id
      }
    }, [_vm._v("RR" + _vm._s(reservation_rate.id) + " " + _vm._s(reservation_rate.name))])
  }), 0)])])]), _c('div', {
    staticClass: "row column"
  }, [_c('label', [_vm._v("Description")]), _c('Editor', {
    model: {
      value: (_vm.body.description),
      callback: function($$v) {
        _vm.$set(_vm.body, "description", $$v)
      },
      expression: "body.description"
    }
  })], 1), _c('div', {
    staticClass: "row column"
  }, [_c('label', [_vm._v("Extended Description")]), _c('Editor', {
    model: {
      value: (_vm.body.extended_description),
      callback: function($$v) {
        _vm.$set(_vm.body, "extended_description", $$v)
      },
      expression: "body.extended_description"
    }
  })], 1), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.save
    },
    slot: "footer"
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54606e23!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/SegmentRateReveal.vue
// module id = 2352
// module chunks = 1